module.exports = "/packs/images/bffs_2026_logo_small~905ab6cb3252f3f74a759860c5c09a58.png";